import { presetGpnDark, presetGpnDefault, Theme } from '@consta/uikit/Theme'
import type { FC, PropsWithChildren } from 'react'

import type { Theme as ThemeType } from './ThemeStore'
import { useGeomateTheme } from './ThemeStore'

function getPreset(value: ThemeType) {
  switch (value) {
    case 'dark':
      return presetGpnDark
    case 'light':
      return presetGpnDefault
  }
}

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const [theme] = useGeomateTheme()

  return <Theme preset={getPreset(theme)}>{children}</Theme>
}
